import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 项目主体css
import './assets/css/app.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/css/theme/main.css'; // 默认主题
import './assets/css/theme/color-dark.css'; /*深色主题*/


import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'zh',
    messages
});

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import Swiper,{Mousewheel} from "swiper"
Swiper.use(Mousewheel)

import store from './store'; 

import globalConfig from './utils/global-config.js' // this.$api 等多种方法

Vue.config.productionTip = false

Vue.use(globalConfig)
Vue.use(ElementUI, {
  size: 'small'
})

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
  template: '<App/>',
}).$mount('#app')
